'use es6';

import { FINDER_FILES_BULK_DELETE, FINDER_FOLDERS_BULK_DELETE, FINDER_FOLDER_CONTENTS_MOVE } from 'DesignData/actions/ActionTypes';
import * as FoldersActions from 'DesignData/actions/finder/Folders';
import * as finderSelectors from 'DesignData/selectors/finder';
export default (({
  getState,
  dispatch
}) => next => action => {
  const previousState = getState();
  const result = next(action);

  switch (result.type) {
    case FINDER_FILES_BULK_DELETE:
      {
        const {
          results
        } = result;

        if (!results) {
          break;
        }

        const files = results.reduce((list, {
          id,
          succeeded
        }) => {
          const {
            folderId
          } = finderSelectors.getFile(previousState, {
            fileId: id
          });

          if (succeeded && folderId) {
            list.push({
              id,
              folderId
            });
          }

          return list;
        }, []);
        dispatch(FoldersActions.bulkDeleteContents({
          files
        }));
        break;
      }

    case FINDER_FOLDERS_BULK_DELETE:
      {
        const {
          results
        } = result;

        if (!results) {
          break;
        }

        let files = [];
        let subfolders = [];
        results.forEach(({
          id: folderId,
          succeeded
        }) => {
          if (succeeded) {
            const {
              parentFolderId
            } = finderSelectors.getFolder(previousState, {
              folderId
            });
            const nestedContents = finderSelectors.getNestedFolderContents(previousState, {
              folderId
            });
            files = files.concat(nestedContents.files.map(id => {
              return {
                id,
                folderId
              };
            }));
            subfolders = subfolders.concat({
              id: folderId,
              folderId: parentFolderId
            }).concat(nestedContents.subfolders.map(id => {
              return {
                id,
                folderId
              };
            }));
          }
        });
        dispatch(FoldersActions.bulkDeleteContents({
          files,
          subfolders
        }));
        break;
      }

    case FINDER_FOLDER_CONTENTS_MOVE:
      {
        const {
          results,
          folderContents
        } = result;

        if (!(results && folderContents)) {
          break;
        }

        const {
          folder,
          files,
          subfolders
        } = folderContents;
        dispatch(FoldersActions.fetchContents.receive({
          folder,
          files,
          subfolders
        }));
        break;
      }

    default:
      break;
  }

  return result;
});